import {Component, OnInit, ElementRef} from '@angular/core';
import {RicambiService} from '../service/ricambi.service';

import {Macchina} from '../models/macchina';
import {Categoria} from '../models/categoria';
import {ActivatedRoute, Params} from '@angular/router';
import {Location} from '@angular/common';
import 'rxjs/add/operator/switchMap';
import {Tavola} from '../models/tavola';
import {Ricambio} from '../models/ricambio';
import {Carrello} from '../models/carrello';
import {MatSnackBar} from '@angular/material';
import {UserService} from '../service/user.service';

@Component({
    selector: 'app-tws-macchina',
    templateUrl: './tws-macchina.component.html',
    styleUrls: ['./tws-macchina.component.css']
})
export class TwsMacchinaComponent implements OnInit {
    macchinaSelezionata: Macchina;
    tavolaCorrente: Tavola;
    imgWidth: number = 100;
    qta:number=1;
    tutteCategorie: Array<Categoria> = new Array<Categoria>();//in teoria ho l'albero e posso metterlo in cache

    constructor(
        private ricambiService: RicambiService,
        private userService: UserService,
        private route: ActivatedRoute,
        private location: Location,
        private elementRef: ElementRef,
        public snackBar: MatSnackBar
    ) {
    }

    ngOnInit(): void {
        this.ricambiService.getCategorie().then(heroes => {this.tutteCategorie = heroes;});
        this.route.params.switchMap((params: Params) => this.ricambiService.getMacchina(+params['id']))
            .subscribe(macchina => this.caricato(macchina));
    }

    caricato(m: Macchina): void {
        this.macchinaSelezionata = m;
        if (m.tavole && m.tavole.length > 0) {
            this.tavolaCorrente = m.tavole[0];
        }

       // window["wheelzoom"](this.elementRef);
    }
    mouseWheelUpFunc() {
        console.log('mouse wheel up');
        this.imgWidth = this.imgWidth + 10;
    }

    mouseWheelDownFunc() {
        console.log('mouse wheel down' + this.imgWidth);
        this.imgWidth = this.imgWidth - 10;
    }

    scegliTavola(tavola: Tavola): void {
        console.log("scelto");
        console.log("img" + tavola.img);
        this.tavolaCorrente = tavola;
    }
    
    aggiungiMacchinaCarrello():void{
        let qta=1;
        if(this.qta && this.qta>1){
            qta=this.qta;
        }
        this.ricambiService.aggiungiCarrello(this.macchinaSelezionata.id, qta).then(carrello => this.aggiuntaMacchina(carrello));
    }
    aggiungiCarrello(ricambio: Ricambio): void {
        let qta=1;
        if(ricambio.qta && ricambio.qta>1){
            qta=ricambio.qta;
        }
        this.ricambiService.aggiungiCarrello(ricambio.id, qta).then(carrello => this.aggiunto(carrello));

    }
    aggiuntaMacchina(carrello: Carrello) {
        this.snackBar.open(RicambiService.traduci("Macchina aggiunta al carrello"), "", {duration: 2000});
    }

    aggiunto(carrello: Carrello) {
        this.snackBar.open(RicambiService.traduci("Prodotto aggiunto al carrello"), "", {duration: 2000});
    }
    
    get utente():any{
        return this.userService.getProfilo();
    }


    get navigazione(): Array<Categoria> {
        let list: Categoria[] = new Array<Categoria>();
        let cat =this.macchinaSelezionata.categoria;
        if (this.tutteCategorie && cat && cat.id>0) {
            let l = new Array<Categoria>();
            while (cat.id > 0) {
                list.push(cat);
                l = this.tutteCategorie.filter(categoria => categoria.id == cat.padre);
                if (l.length > 0) {
                    cat = l[0];
                } else {
                    cat = new Categoria(0, "", "", 0);
                }
            }
            return list.reverse();
        }else{
            return list;
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/tws-macchina/tws-macchina.component.ts